import React from 'react';
import { GradientDefs, VerticalRectSeries } from 'react-vis';
import { CollapsedTick } from './collapseDataGaps';

// Diagonal hatch pattern used to mark collapsed data-void columns.
const VOID_HATCH_ID = 'voidGapHatch';

// Renders a striped band centered on the x-axis under each collapsed multi-year void column, making
// it obvious that a stretch of years was compressed away. Single-year gaps are just an empty year
// column (nothing was collapsed), so they get no marker. Returns react-vis elements meant to be
// spread as direct children of an XYPlot (so react-vis injects the x/y scales), or null when there
// are no multi-year voids. Render these AFTER the XAxis so the band paints on top of the axis line
// rather than being overlapped by it.
export const renderVoidMarkers = (ticks: CollapsedTick[], yDomain: number[]): React.ReactNode[] | null => {
  const voids = ticks.filter(
    (t) => t.year === undefined && t.multiYear && t.start !== undefined && t.end !== undefined,
  );
  if (voids.length === 0) {
    return null;
  }

  const yRange = yDomain[1] - yDomain[0];
  const half = yRange * 0.01;
  const top = yDomain[0] + half;
  const bottom = yDomain[0] - half;
  const data = voids.map((v) => ({ x0: v.start as number, x: v.end as number, y0: bottom, y: top }));

  return [
    <GradientDefs key="voidGapDefs">
      <pattern id={VOID_HATCH_ID} width={6} height={6} patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
        <rect width={6} height={6} fill="#eee" />
        <line x1={0} y1={0} x2={0} y2={6} stroke="#b0b0b0" strokeWidth={2} />
      </pattern>
    </GradientDefs>,
    <VerticalRectSeries
      key="voidGapRects"
      data={data}
      colorType="literal"
      color={`url(#${VOID_HATCH_ID})`}
      stroke="#b0b0b0"
    />,
  ];
};
